import {
  PageLayoutSubtitle,
  PageLayoutTitle,
} from '@crehana/compass.web/page-layout';
import type { ReactNode } from 'react';

/**
 * Wraps page title, subtitle and an optional actions area (e.g. primary CTAs).
 * Use the `actions` slot to render one or more buttons; layout and spacing are handled here.
 *
 * TODO: Move this component to @crehana/compass.web/page-layout.
 */
type PageHeaderWithActionsProps = {
  actions?: ReactNode;
  subtitle: ReactNode;
  title: string;
};

export const PageHeaderWithActions = ({
  actions,
  subtitle,
  title,
}: PageHeaderWithActionsProps) => {
  const titleBlock = (
    <div className="tw-space-y-0.8">
      <PageLayoutTitle title={title} />
      <PageLayoutSubtitle>{subtitle}</PageLayoutSubtitle>
    </div>
  );

  if (actions == null) {
    return (
      <div className="tw-flex tw-items-end tw-justify-between tw-gap-2.4 tw-pb-1.6">
        {titleBlock}
      </div>
    );
  }

  return (
    <div className="tw-flex tw-items-end tw-justify-between tw-gap-2.4 tw-pb-1.6">
      {titleBlock}
      <div className="tw-flex tw-items-center tw-gap-2.4">{actions}</div>
    </div>
  );
};
